import { createStructuredSelector } from 'reselect';
import {
    INFRA_LOGBOOK_LIST, INFRA_LOGBOOK_LIST_SUCCESS, INFRA_LOGBOOK_LIST_ERROR,
    INFRA_LOGBOOK_PAGE_SET, INFRA_LOGBOOK_SEARCH_CHANGE,
    INFRA_LOGBOOK_ADD_MODAL_SET, INFRA_LOGBOOK_ADD_CHANGE,
    INFRA_LOGBOOK_ADD, INFRA_LOGBOOK_ADD_SUCCESS, INFRA_LOGBOOK_ADD_ERROR,
    INFRA_LOGBOOK_EDIT_MODAL_SET, INFRA_LOGBOOK_EDIT_SET_DATA,
    INFRA_LOGBOOK_UPDATE, INFRA_LOGBOOK_UPDATE_SUCCESS, INFRA_LOGBOOK_UPDATE_ERROR,
    INFRA_LOGBOOK_CONTRACT_ERP_DATA, INFRA_LOGBOOK_CONTRACT_ERP_DATA_SUCCESS,
    INFRA_LOGBOOK_CONTRACT_ERP_DATA_ERROR,
    INFRA_LOGBOOK_SAVE_CONTRACT, INFRA_LOGBOOK_SAVE_CONTRACT_SUCCESS,
    INFRA_LOGBOOK_SAVE_CONTRACT_ERROR,
    INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES, INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_SUCCESS,
    INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_ERROR,
} from '../../actions';

export const NAME = 'infrastructureLogbook';

export const InfrastructureLogbookList = (page, num_page, orderBy, filters) => ({
    type: INFRA_LOGBOOK_LIST,
    payload: { page, num_page, orderBy, filters }
});
export const InfrastructureLogbookListSuccess = (data) => ({ type: INFRA_LOGBOOK_LIST_SUCCESS, payload: data });
export const InfrastructureLogbookListError = (error) => ({ type: INFRA_LOGBOOK_LIST_ERROR, payload: error });
export const InfrastructureLogbookPageSet = (data) => ({ type: INFRA_LOGBOOK_PAGE_SET, payload: data });
export const InfrastructureLogbookSearchChange = (data) => ({ type: INFRA_LOGBOOK_SEARCH_CHANGE, payload: data });

export const InfrastructureLogbookAddModalSet = (data) => ({ type: INFRA_LOGBOOK_ADD_MODAL_SET, payload: data });
export const InfrastructureLogbookAddChangeSet = (data) => ({ type: INFRA_LOGBOOK_ADD_CHANGE, payload: data });
export const InfrastructureLogbookAdd = (data) => ({ type: INFRA_LOGBOOK_ADD, payload: data });
export const InfrastructureLogbookAddSuccess = (data) => ({ type: INFRA_LOGBOOK_ADD_SUCCESS, payload: data });
export const InfrastructureLogbookAddError = (error) => ({ type: INFRA_LOGBOOK_ADD_ERROR, payload: error });

export const InfrastructureLogbookEditModalSet = (data) => ({ type: INFRA_LOGBOOK_EDIT_MODAL_SET, payload: data });
export const InfrastructureLogbookEditSetData = (data) => ({ type: INFRA_LOGBOOK_EDIT_SET_DATA, payload: data });
export const InfrastructureLogbookUpdate = (data) => ({ type: INFRA_LOGBOOK_UPDATE, payload: data });
export const InfrastructureLogbookUpdateSuccess = (data) => ({ type: INFRA_LOGBOOK_UPDATE_SUCCESS, payload: data });
export const InfrastructureLogbookUpdateError = (error) => ({ type: INFRA_LOGBOOK_UPDATE_ERROR, payload: error });

export const InfrastructureLogbookContractERPData = (contract) => ({ type: INFRA_LOGBOOK_CONTRACT_ERP_DATA, payload: contract });
export const InfrastructureLogbookContractERPDataSuccess = (data) => ({ type: INFRA_LOGBOOK_CONTRACT_ERP_DATA_SUCCESS, payload: data });
export const InfrastructureLogbookContractERPDataError = (error) => ({ type: INFRA_LOGBOOK_CONTRACT_ERP_DATA_ERROR, payload: error });

export const InfrastructureLogbookSaveContract = (data) => ({ type: INFRA_LOGBOOK_SAVE_CONTRACT, payload: data });
export const InfrastructureLogbookSaveContractSuccess = (data) => ({ type: INFRA_LOGBOOK_SAVE_CONTRACT_SUCCESS, payload: data });
export const InfrastructureLogbookSaveContractError = (error) => ({ type: INFRA_LOGBOOK_SAVE_CONTRACT_ERROR, payload: error });

export const InfrastructureLogbookUpdateContractNotes = (data) => ({ type: INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES, payload: data });
export const InfrastructureLogbookUpdateContractNotesSuccess = (data) => ({ type: INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_SUCCESS, payload: data });
export const InfrastructureLogbookUpdateContractNotesError = (error) => ({ type: INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_ERROR, payload: error });

const infrastructureLogbook = (state) => state[NAME];
export const InfrastructureLogbookSelector = createStructuredSelector({ infrastructureLogbook });